import { Address } from "@silo/types";
import { createLocalContext } from "../../utils/create-local-context";

export const { LendingLinkContext, useLendingLinkContext } =
  createLocalContext<{
    marketAddress: Address;
    tokenAddress?: Address;
    disabled: boolean;
  }>()("LendingLink");
